export const isProd = () => {
  return window._env_.REACT_APP_STAGE_IND && window._env_.REACT_APP_STAGE_IND === "production"
};

export const ENTORNO = window._env_.REACT_APP_ENTORNO;

export const APP = {
  ANDROID_VERSION: window._env_.REACT_APP_ANDROID_VERSION,
  IOS_VERSION: window._env_.REACT_APP_IOS_VERSION
  };

export const APIGATEWAY =
  {
    URL: window._env_.REACT_APP_APIMANAGER,
    AUTH: "ECCO_IND_AUTH",
    APIKEY: window._env_.REACT_APP_APIMANAGER_ECCO_IND_KEY
  };

export const RESTBLOG =
  {
    URL: window._env_.REACT_APP_APIMANAGER,
    AUTH: null
  };

export const PUBLICURL = window._env_.PUBLIC_URL;

export const WEBPAGE = window._env_.REACT_APP_WEB_PAGE_IND;

export const RECAPTCHA = {
  PUBLICKEY: window._env_.REACT_APP_RECAPTCHA_SITEKEY,
  APIMANAGERKEY: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_KEY_IND,
  APIMANAGERUSER: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_USER_IND,
  APIMANAGERPASS: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_PASS_IND,
};

export const GOOGLEMAPS = {
  APIKEY: window._env_.REACT_APP_GOOGLE_MAPS_KEY,
  CLIENTID: window._env_.REACT_APP_GOOGLE_MAPS_CLIENT_ID
};

export const STATICPAGES = window._env_.REACT_APP_STATICPAGES;

export const ASSETS_S3 = window._env_.REACT_APP_ASSETS_IND;

export const INACTIVITY_TIMEOUT = {
  PANEL: window._env_.REACT_APP_PANEL_INACTIVITY_LOGOUT,
  REGISTRATION: window._env_.REACT_APP_REGISTRATION_INACTIVITY_GOLOGIN,
  DEFAULT_EVENTS: [
    "keydown",
    "mousedown",
    "touchstart",
    "MSPointerDown",
    "visibilitychange"
  ]
};

export const GOOGLE_TAGMANAGER = {
  ID: window._env_.REACT_APP_GOOGLE_TAGMANAGER_ID_WAP,
  AUTH: window._env_.REACT_APP_GOOGLE_TAGMANAGER_AUTH_WAP,
  PREVIEW_ENV: window._env_.REACT_APP_GOOGLE_TAGMANAGER_PREVIEWENV_WAP
};